import { Action, createReducer, on } from "@ngrx/store";
import * as fromActions from './lastplayers.actions';
import * as fromState from './lastplayers.state';

const lastplayersReducer = createReducer(
    fromState.getInitialLastplayersState(),
    on(
        fromActions.loadManySuccess,
        (state, { items }) => {
            return fromState.adapter.upsertMany(items!.map(item => {
                return { ...item, id: item.requestId } as fromState.LastplayersEntity
            }), state);
        }),
);

export function reducer(state: fromState.LastplayersState | undefined, action: Action) {
    return lastplayersReducer(state, action);
}